import { liveStats } from '@/mqtt/liveStats'
import { resourcesSubscriber } from '@/mqtt/resources'

function init() {
  liveStats.connect()
  resourcesSubscriber.init()
}

export default { init }
